"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionRoot = exports.SelectorItem = exports.SelectorRoot = exports.List = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ROOT_PADDING_TOP = 12;
var ROOT_PADDING_LR = 30; // TODO: 既存画面調整後に 0 に変える
var ROOT_PADDING_BOTTOM = 0;
var HEADER_HEIGHT = 32;
var BODY_PADDING_TOP = 16;
var BODY_PADDING_LR = 0;
var BODY_PADDING_BOTTOM = 0;
var PREVIEW_WIDTH = 250;
/**
 * リスト構造の描画を行う
 *
 * ヘッダ部（上部）とリスト部（下部）が描画される。<br>
 * ヘッダ部左側に selector が、ヘッダ部右側に action が、それぞれ描画される。<br>
 * preview を与えていた場合、リスト部の右側に描画される。
 * children は、リスト部の全体（previewを与えていない時）または左側（previewを与えている時）に描画される。<br>
 */
var List = function (props) {
    return (react_1.default.createElement(ListPane, null,
        react_1.default.createElement(HeaderPane, null,
            react_1.default.createElement(SelectorPane, null, props.selector),
            react_1.default.createElement(ActionPane, null, props.action)),
        react_1.default.createElement(BodyPane, null,
            props.scrollRef ? (react_1.default.createElement(LinesPane, { ref: props.scrollRef, preview: !!props.preview }, props.children)) : (react_1.default.createElement(LinesPane, { preview: !!props.preview }, props.children)),
            props.preview ? react_1.default.createElement(PreviewPane, null, props.preview) : null)));
};
exports.List = List;
var ListPane = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n\n  box-sizing: border-box;\n  height: 100%;\n  padding: ", "px ", "px ", "px;\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  box-sizing: border-box;\n  height: 100%;\n  padding: ", "px ", "px ", "px;\n"])), ROOT_PADDING_TOP, ROOT_PADDING_LR, ROOT_PADDING_BOTTOM);
var HeaderPane = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex: 0 0 ", "px;\n  align-items: flex-end;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex: 0 0 ", "px;\n  align-items: flex-end;\n"])), HEADER_HEIGHT);
var SelectorPane = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var ActionPane = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""])));
var BodyPane = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex: 1 0 auto;\n\n  box-sizing: border-box;\n  max-height: calc(100% - ", "px);\n  padding: ", "px ", "px ", "px;\n"], ["\n  display: flex;\n  flex: 1 0 auto;\n\n  box-sizing: border-box;\n  max-height: calc(100% - ", "px);\n  padding: ", "px ", "px ", "px;\n"])), HEADER_HEIGHT, BODY_PADDING_TOP, BODY_PADDING_LR, BODY_PADDING_BOTTOM);
var LinesPane = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  max-width: ", ";\n  flex: 1 0 auto;\n  overflow-x: scroll;\n  @media print {\n    overflow-x: visible;\n  }\n"], ["\n  max-width: ", ";\n  flex: 1 0 auto;\n  overflow-x: scroll;\n  @media print {\n    overflow-x: visible;\n  }\n"])), function (props) { return (props.preview ? "calc(100% - ".concat(PREVIEW_WIDTH + ROOT_PADDING_LR * 2, "px)") : undefined); });
var PreviewPane = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  flex: 0 0 ", "px;\n\n  box-sizing: border-box;\n  max-height: 100%;\n  margin-left: 30px;\n"], ["\n  flex: 0 0 ", "px;\n\n  box-sizing: border-box;\n  max-height: 100%;\n  margin-left: 30px;\n"
    /**
     * リスト構造に渡す selector のルート
     */
])), PREVIEW_WIDTH);
/**
 * リスト構造に渡す selector のルート
 */
exports.SelectorRoot = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  padding-top: 8px;\n"], ["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  padding-top: 8px;\n"
    /**
     * リスト構造に渡す selector アイテム一つ一つ
     */
])));
/**
 * リスト構造に渡す selector アイテム一つ一つ
 */
exports.SelectorItem = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin-right: 30px;\n  &:last-child {\n    margin-right: 0;\n  }\n"], ["\n  margin-right: 30px;\n  &:last-child {\n    margin-right: 0;\n  }\n"
    /**
     * リスト構造に渡す action のルート
     */
])));
/**
 * リスト構造に渡す action のルート
 */
exports.ActionRoot = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n\n  & > * {\n    margin-left: 16px;\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n"], ["\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n\n  & > * {\n    margin-left: 16px;\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
